import { isPromoteInputFeedbackReply } from 'components/Reply/reply-type';
import { useMemo } from 'react';
import { useConversation } from 'state/conversation';
import { useHasAgentConversationStarted } from 'state/hasAgentConversationStarted';

/**
 * useIsWaitingForFeedback
 * Check the last message of conversation to find out whether
 * is waiting for user feedback
 * @returns {boolean}
 */
export const useIsWaitingForFeedback = () => {
  const conversation = useConversation();
  const hasAgentConversationStarted = useHasAgentConversationStarted();

  return useMemo(() => {
    return (
      isPromoteInputFeedbackReply(
        conversation[conversation.length - 1]?.replyType,
      ) ||
      (!!hasAgentConversationStarted &&
        !!conversation[conversation.length - 1]?.isAgentFeedback)
    );
  }, [conversation, hasAgentConversationStarted]);
};
